import { render } from "./RadixTariffInput.vue?vue&type=template&id=723c0d93"
import script from "./RadixTariffInput.vue?vue&type=script&lang=js"
export * from "./RadixTariffInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__